import { useCallback } from 'react';

import log from 'loglevel';

import { useUnsnoozeEmail } from '../../../services/snoozedEmails.service';

export const useUnsnoozeUserCommunication = () => {
  const { unsnoozeEmail, loading: isUnsnoozing } = useUnsnoozeEmail();

  const handleUnsnoozeUserCommunication = useCallback(
    async (snoozeId: string): Promise<boolean> => {
      try {
        return await unsnoozeEmail(snoozeId);
      } catch (error) {
        log.error('useUnsnoozeUserCommunication: unsnoozeEmail failed', {
          snoozeId,
          error,
        });
        return false;
      }
    },
    [unsnoozeEmail],
  );

  return { handleUnsnoozeUserCommunication, isUnsnoozing };
};
